<template>
  <div class="side-box" :class="{ active: opened.length > 0 }">
    <span class="side-box__overlay" />
    <div
      v-if="project"
      class="side-box__inner"
      :class="{
        opened: opened.indexOf('services') >= 0,
        'last-active': opened.indexOf('services') == opened.length - 1
      }"
    >
      <div
        class="side-box__header d-flex justify-content-between align-items-center"
      >
        <div
          class="atom-back atom-back--gray"
          @click="$emit('closeBox', 'services')"
        >
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" /><span>{{
              $t("zpet")
            }}</span>
          </div>
        </div>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("sluzbyProjektu") }} {{ project.projectName }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="services.length > 0" class="my-4">
          <div class="d-flex">
            <span class="messages__timestamps__col endpoits gray-text">{{
              $t("custServiceId")
            }}</span>
            <span class="messages__timestamps__col gray-text">{{
              $t("tarifName")
            }}</span>
          </div>
          <div
            v-for="service in services"
            :key="service.custServiceId"
            class="d-flex messages__timestamps__item"
          >
            <span class="messages__timestamps__col endpoits">{{
              $t(service.custServiceId)
            }}</span>
            <span class="messages__timestamps__col">{{
              service.tarifName
            }}</span>
          </div>
        </div>
        <div v-else class="my-4">
          <p>{{ $t("nicKZobrazeni") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useAdminStore } from "@/store/modules/admin"
export default {
  components: {},
  props: {
    project: Object,
    opened: Array
  },
  setup() {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  data() {
    return {
      services: []
    };
  },
  computed: {
    storedCustomer() {
      return this.adminStore.customer
    }
  },
  watch: {
    storedCustomer() {
      this.loadServices();
    }
  },
  mounted() {
    if (this.storedCustomer) {
      this.loadServices();
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box);
    },
    closeBox(box) {
      if (box === "services") {
        //this.resetValues();
        this.$emit("closeBox", box);
      } else {
        //this.resetValues();
        this.errors.endpoint = "";
        this.$emit("closeBox", box);
      }
    },
    loadServices() {
      this.services = [];
      axios
        .get(
          process.env.VUE_APP_API +
            "/projects/" +
            this.project.projectId +
            "/services?discontinued[eq]=0&limit=1000"
        )
        .then(result => {
          this.services = result.data.data;
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped></style>
